export default __webpack_public_path__ + "static/media/assigned-status.4ae2bbe5.svg";